import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON009_Request,
  IAPI_CON009_Response,
} from "../../../type/apiType";

// 契約者氏名等変更届・共済契約証書再交付申出参照
const httpAPI_CON009 = async (
  param: IAPI_CON009_Request
): Promise<IAPI_CON009_Response> => {
  let res = await http.post(ApiUrl.API_CON009, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON009, httpAPI_APP016 };
